// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3fc0a8cc","380":"03575968","453":"79ec2a8e","541":"600bf55b","687":"2e89e10c","711":"54cf59aa"}[chunkId] + ".chunk.js";
};